import { render } from "./Index.vue?vue&type=template&id=002fe2d8&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-002fe2d8"

export default script